import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { API } from '../api';

/**
 * Attaches the Authorization bearer token (ID token) to outbound P0 API requests.
 */
export const authHeaderInterceptor: HttpInterceptorFn = (
	req: HttpRequest<unknown>,
	next: HttpHandlerFn,
) => {
	const oAuth = inject(OAuthService);

	// Only apply to calls that start with the API base URL and if no Authorization header is already present
	if (!req.url.startsWith(API.base) || req.headers.has('Authorization')) return next(req);

	const idToken = oAuth.getIdToken();

	// Skip if no token available
	if (!idToken) return next(req);

	const cloned = req.clone({ setHeaders: { Authorization: `Bearer ${idToken}` } });

	return next(cloned);
};
